import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import EditDictionarySortableItemForm from "../form/edit/EditDictionarySortableItemForm";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";

interface IComponentProps {
	/**
	 * Title for edit modal
	 */
	title: string
	/**
	 * On successful edited item callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Item to edit.
	 */
	item: DictionaryItem;
	/**
	 * Update item action
	 * @param {string} itemId
	 * @param {DictionaryItem} item
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	onUpdateItem: (itemId: string, item: DictionaryItem, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Error handler
	 * @param err
	 * @returns {string | null}
	 */
	errorHandler?: (err: any) => string | null
}

export default class EditDictionarySortableItemModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal autoWidth onCloseClicked={this.props.onCancel} title={`Edit ${this.props.title}`}>
				<EditDictionarySortableItemForm title={this.props.title}
												item={this.props.item}
												onSuccess={this.props.onSuccess}
												onCancel={this.props.onCancel}
												onUpdateItem={this.props.onUpdateItem}
												errorHandler={this.props.errorHandler}/>
			</Modal>
		);
	}
}
